/**
 * Values of the `declencheur` field returned by the API that indicate a manual reading.
 * Any value not in this set is considered automatic.
 * Source: internal DTD sensor documentation.
 */
export const MANUAL_TRIGGER_VALUES = new Set([0, 3, 5, 8])

export const TRIGGER_LABEL_MANUAL = 'Manuel'
export const TRIGGER_LABEL_AUTOMATIC = 'Automatique'

export function triggerLabel(value) {
  return MANUAL_TRIGGER_VALUES.has(value) ? TRIGGER_LABEL_MANUAL : TRIGGER_LABEL_AUTOMATIC
}
